import type { RefOrGetter } from "ls/common/types";
import type { ShortcutJs } from "@/generated/models";
import { ClickthroughSm, DesignSm, DocSm, LibRpSm, RpSm, TeamLibRpSm, TeamRpSm, WhiteboardSm } from "ls/components/icons";
import { FileIcon, LinkIcon } from "lucide-vue-next";
import { computed, toValue } from "vue";
import { ShortcutType } from "@/generated/models";
import { isBookmarkShortcutType, isClickthroughProjectType, isDesignProjectType, isDocumentProjectType, isRpProjectType, isWhiteboardProjectType } from "./utils";

const rpIcons = {
  [ShortcutType.Rp]: RpSm,
  [ShortcutType.Lib]: LibRpSm,
  [ShortcutType.TeamRp]: TeamRpSm,
  [ShortcutType.TeamLib]: TeamLibRpSm,
} as const;

export function getIconFromShortcutType(type: ShortcutType) {
  if (isRpProjectType(type)) {
    const rpType = type as keyof typeof rpIcons;
    return rpIcons[rpType] ?? RpSm;
  }
  if (isClickthroughProjectType(type)) return ClickthroughSm;
  if (isDocumentProjectType(type)) return DocSm;
  if (isWhiteboardProjectType(type)) return WhiteboardSm;
  if (isDesignProjectType(type)) return DesignSm;
  if (isBookmarkShortcutType(type)) return LinkIcon;
  return FileIcon;
}

export function useFileIcon(file: RefOrGetter<ShortcutJs>) {
  return computed(() => getIconFromShortcutType(toValue(file).ShortcutType));
}
